// eslint-disable-next-line
// @ts-nocheck

import * as React from "react";

import {
    DropDownTree,
    DropDownTreeChangeEvent,
    DropDownTreeExpandEvent,
    DropDownTreeFilterChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { processTreeData, expandedState } from "./tree-data-operations";
import './style.scss'
import { FilterDescriptor } from "@progress/kendo-data-query";

const selectField = "selected";
const expandField = "expanded";
const dataItemKey = "id";
const textField = "text";
const subItemsField = "items";
const fields = { selectField, expandField, dataItemKey, subItemsField };

const DropdownTreeFilter = ({ data, value, handleChange, width = '100%', withClearIcon = false, label = "", element = '', itemKey='' }) => {
    const [expanded, setExpanded] = React.useState([]);
    const [open, setOpen] = React.useState(false)
    const [filter, setFilter] = React.useState<FilterDescriptor>({
        value: "",
        operator: "contains",
    });
    const [preventClose, setPreventClose] = React.useState(false)
    
    // Use ref to track value.id to prevent unnecessary recalculations
    const valueIdRef = React.useRef(value?.id);
    const stableValueId = value?.id;
    
    React.useEffect(() => {
        valueIdRef.current = stableValueId;
    }, [stableValueId]);

    // Fix: Use functional setState to avoid needing expanded in dependency array
    const onExpandChange = React.useCallback(
      (event: DropDownTreeExpandEvent) => {
        setExpanded((prevExpanded) => expandedState(event.item, dataItemKey, prevExpanded))
      },
      [],
    )

    const onChange = React.useCallback((event: DropDownTreeChangeEvent) => {
      if (event?.value?.items) {
        onExpandChange({
          item: event.value,
          level: event.level,
          value: event.value,
        })
        setPreventClose(true)
      } else {
        handleChange(event?.value, element, itemKey)
      }
    }, [onExpandChange, handleChange, element, itemKey])

    const treeData = React.useMemo(
        () => processTreeData(data, { expanded, value, filter }, fields),
        [expanded, value, filter, data]
    );

    const onFilterChange = React.useCallback((event: DropDownTreeFilterChangeEvent) => {
        setFilter(event.filter);
    }, []);

    // Memoize Item component - use props.item.selected instead of comparing with value
    // This prevents recreation when value changes
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Item = React.useCallback((props: ItemProps) => {
        return (
          <span className={`dropdownItem ${props.item.isDisabled ? "disabledItem" : ""} ${props.item.selected ? "selectedDropdownValue" : ""} `}>
            {props.item[textField]}
          </span>
        )
    }, []); // Empty dependency array - component is now stable

    React.useEffect(() => {
      if (preventClose) {
        setOpen(true)
        setPreventClose(false)
      }
    }, [preventClose])

    return (
      <div style={{ width: width || "100%", display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
        {!!label && <span style={{ whiteSpace: "nowrap" }}>{label}</span>}
        <DropDownTree
          opened={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          style={{ width: width || "100%", maxHeight: 300, overflowY: "auto" }}
          placeholder="Select"
          data={treeData}
          value={value}
          onChange={onChange}
          item={Item}
          textField={textField}
          dataItemKey={dataItemKey}
          selectField={selectField}
          expandField={expandField}
          onExpandChange={onExpandChange}
          filterable={true}
          onFilterChange={onFilterChange}
          filter={filter.value}
          popupSettings={{
            popupClass: 'dropdown-tree-filter-popup'
          }}
        />
      </div>
    )
};

export default DropdownTreeFilter